import { TOGGLE_EVT } from "./events";

interface ToggleProps {
  element: Element | null;
  attribute: string;
  action?: string;
  value?: string | boolean;
  dispatchEvent?: boolean;
  eventDetail?: {
    trigger: Element;
    element: Element;
  };
}

export default function toggle(props: ToggleProps): string | boolean | null {
  const {
    element,
    attribute,
    action,
    value,
    dispatchEvent = true,
    eventDetail,
  } = props;
  let returnValue: string | boolean | null = null;

  if (!element || !(element instanceof Element)) {
    return returnValue;
  }

  if (action === "focus") {
    setTimeout(() => (element as HTMLElement).focus(), 20);
  }

  if (action === "click") {
    (element as HTMLElement).click();
  }

  if (attribute === "class" && typeof value === "string") {
    element.classList.toggle(value);
    returnValue = value;
  }

  if (attribute === "text") {
    const oldText = element.textContent;
    element.textContent = value?.toString() || "";
    returnValue = oldText;
  }

  if (
    attribute !== "class" &&
    attribute !== "text" &&
    typeof action === "undefined"
  ) {
    returnValue = element.getAttribute(attribute);

    if (attribute === "hidden") {
      if (element.hasAttribute(attribute)) {
        element.removeAttribute(attribute);
      } else {
        element.setAttribute(attribute, "");
      }
    } else if (!value) {
      element.setAttribute(attribute, String(!(returnValue === "true")));
    } else {
      element.setAttribute(attribute, String(value));
    }
  }

  if (dispatchEvent) {
    element.dispatchEvent(
      new CustomEvent(TOGGLE_EVT, {
        detail: eventDetail,
        bubbles: true,
      }),
    );
  }

  return returnValue;
}
